import useTitanApp from "../../../hooks/useTitanApp";
import {
  deletePatientMedications,
  setCurrentPatientMedicationsToDelete,
  getPatientMedications,
} from "../../../dispatchers/patientDispatchers";
import { Modal } from "react-bootstrap";
import { IoClose } from "react-icons/io5";
import { LuPill } from "react-icons/lu";
import "../../../assets/css/PatientDeleteMedicationsModal.scss";

export default function PatientDeleteMedicationsModal() {
  const { appState, patientState } = useTitanApp();
  const { darkMode } = appState || {};
  const {
    selectedPatientDetails,
    showDeleteMedicationsModal,
    deletePatientMedicationsLoader,
    selectedPatientMedications,
    consultationId,
  } = patientState || {};

  const closeModal = () => {
    setCurrentPatientMedicationsToDelete(null);
  };

  const handleDeleteClick = async () => {
    if (!selectedPatientMedications) return;

    try {
      let lstMedications = [];
      const medication = {
        ItemName: selectedPatientMedications?.itemName || "",
        Dose: selectedPatientMedications?.dose || "",
        Quantity: selectedPatientMedications?.quantity || "",
        TherapyLevel: selectedPatientMedications?.therapyLevel || "",
        AdditionalNotes: selectedPatientMedications?.additionalNotes || "",
      };
      lstMedications.push(medication);
      const patientMedications = {
        patientId: selectedPatientDetails?.patientID,
        medications: lstMedications,
        consultationId,
      };
      await deletePatientMedications(patientMedications);
      await getPatientMedications(selectedPatientDetails?.patientID);
      closeModal();
      setCurrentPatientMedicationsToDelete(null);
    } catch (error) {
      console.error("Error in deleting patient medication:", error);
    }
  };
  return (
    <Modal
      show={showDeleteMedicationsModal}
      onHide={closeModal}
      centered
      backdrop="static"
      dialogClassName="pc-modal-delete-medications delete-medications"
      size="md"
    >
      <div className="header">
        <div className="info">
          <p className="label">
            <div>
              <LuPill color={darkMode ? "#bdbdbd" : "#0a0a0a"} />
            </div>
            Delete Medication
          </p>
        </div>
        <IoClose
          size={20}
          color={darkMode ? "#bdbdbd" : "#7c7c7c"}
          onClick={closeModal}
        />
      </div>
      <div className="body">
        <div>
          <p>
            Are you sure you want to delete the medication{" "}
            {selectedPatientMedications
              ? `"${selectedPatientMedications?.itemName}"`
              : "this"}
            ? Do you want to continue?
          </p>
        </div>
        <div className="pc-delete-medications-footer-actions">
          <button className="cancel" type="button" onClick={closeModal}>
            Cancel
          </button>
          <button
            className="done"
            type="submit"
            disabled={deletePatientMedicationsLoader}
            onClick={() => handleDeleteClick()}
          >
            {deletePatientMedicationsLoader === true ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </Modal>
  );
}
